import APIError from "./APIError";

class CreateUserReply {
  error?: APIError;
}

export default CreateUserReply;
